module.exports = __webpack_public_path__ + "static/img/typebg3.c9092ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/typebg3.png
// module id = 1GrW
// module chunks = 8